// src/components/superuser/PortfolioPlaceholder.js
//
// Lightweight "scaffolded, not yet built" page so the full superuser
// information architecture (nav) is navigable from day one while individual
// sections are filled in. Configure per-route via makePlaceholder(title, note).

import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

export function PortfolioPlaceholder({ title, note }) {
  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 1.5,
        }}
      >
        <ConstructionIcon sx={{ fontSize: 48, color: "text.secondary", opacity: 0.5 }} />
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ maxWidth: 560 }}>
          {note || "This section is scaffolded and coming soon."}
        </Typography>
      </Paper>
    </Box>
  );
}

// Factory so each route can render a distinct titled placeholder while still
// receiving the standard route props (userInfo, selectedClient, etc.).
export const makePlaceholder = (title, note) => {
  const Page = () => <PortfolioPlaceholder title={title} note={note} />;
  Page.displayName = `Placeholder(${title})`;
  return Page;
};

export default PortfolioPlaceholder;
